import OpenInNewIcon from './OpenInNewIcon'

export default OpenInNewIcon
